"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Paper_1 = tslib_1.__importDefault(require("@mui/material/Paper"));
const InternalConstants = tslib_1.__importStar(require("./InternalConstants"));
const Sidebar = (props) => {
    const { sx, className, open, children, classes, ...restProps } = props;
    const drawerProps = {
        square: true,
        ...restProps,
        sx: [
            {
                height: `calc(100vh - ${InternalConstants.ARGUS_MENU_HEIGHT + InternalConstants.PAGE_HEADER_HEIGHT}px)`,
                display: "flex",
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ],
    };
    return (react_1.default.createElement(Paper_1.default, { className: "MneSidebar", ...drawerProps, component: "aside" }, children));
};
exports.default = Sidebar;
